(ns hai.ui.components.tabs
  (:require
   [hai.ui.components :as c]
   [lambdaisland.ornament :as o]))

;; Container to wrap over radix's c/TabsRoot
(o/defstyled tabs-container :div
  :border-2 :border-dashed :rounded-lg :max-w-6xl :bg-white
  [:.rt-TabsList
   :overflow-x-auto
   :overflow-y-hidden
   {:-webkit-overflow-scrolling "touch"
    :scrollbar-width "thin"}]
  [:.rt-BaseTabListTriggerInnerBox
   :flex-shrink-0]
  [:.rt-BaseTabListTrigger :px-2 :flex-shrink-0
   ["&[data-state='active']" {:background c/--accent-2}]
   {:--tab-padding-x 0}]
  [:.rt-TabsTriggerInner
   :flex :items-center :gap-2 :h-full :w-full :whitespace-nowrap]
  [:.rt-TabsContent
   :bg-white :p-4 :min-h-44]
  {:border-color "#e0e0e0"})
